import { useInView } from 'react-intersection-observer';
import { useState } from 'react';
import { sendInquiry } from '../services/cms';
import LoadingIndicator from '../components/LoadingIndicator';
import InquiryBannerSection from '../components/sections/inquiry/InquiryBannerSection';
export default function InquiryPage() {
  const [inView, setInView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { ref } = useInView({
    threshold: 0.5,
    onChange: (inViewStatus) => setInView(inViewStatus),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    setIsLoading(true);

    try {
      const result = await sendInquiry(data);
      if (result.redirect) {
        // cms.js에서 302 리다이렉션 응답 처리 시 반환하는 redirect 속성 확인
        alert(result.message); // 성공 메시지 표시
        window.location.href = '/'; // 홈으로 리다이렉트
      } else {
        // 정상 응답이지만 redirect가 아닌 경우
        console.log('문의 전송 성공:', result);
        alert('문의가 성공적으로 전송되었습니다.');
        window.location.href = '/';
      }
    } catch (error) {
      // cms.js에서 throw한 에러 처리
      console.error('문의 전송 중 오류 발생:', error);
      // 필수 필드 누락 등 구체적인 에러 메시지 표시
      alert(error.message || '문의 전송에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div ref={ref} className="">
      <LoadingIndicator isLoading={isLoading} />
      <InquiryBannerSection />
      <div className="desktop:py-[100px] py-[50px] desktop:px-[50px] px-[20px] bg-alternate">

        <div className="bg-primary-background desktop:p-[100px] desktop:px-[50px] px-[20px] py-[30px] desktop:py-[50px] desktop:rounded-[60px] rounded-[30px] shadow-lg">
          <div className={`text-[#2684fc] desktop:text-headline-large text-headline-small font-semibold font-inter desktop:leading-[80px] leading-[40px] ${inView ? 'animate-fadeSlideUp' : ''}`}>입학문의</div>
          <form onSubmit={handleSubmit} className="mt-[30px] desktop:mt-[69px]">
            <div className="grid grid-cols-1 gap-[30px]">
              <div className="flex desktop:items-center items-start desktop:flex-row flex-col w-full desktop:text-headline-small text-title-medium ">
                <label htmlFor="name" className="block w-[160px] font-semibold font-inter desktop:mb-0 mb-3">
                  성함
                </label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  className="flex-1 w-full rounded-md border border-custom2 px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  required
                />
              </div>

              <div className="flex desktop:items-center items-start desktop:flex-row flex-col w-full desktop:text-headline-small text-title-medium ">
                <label htmlFor="contact" className="block w-[160px] font-semibold font-inter desktop:mb-0 mb-3">
                  연락처
                </label>
                <input
                  id="contact"
                  type="text"
                  name="contact"
                  className="flex-1 w-full rounded-md border border-custom2 px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  required
                />
              </div>

              <div className="flex desktop:items-center items-start desktop:flex-row flex-col w-full desktop:text-headline-small text-title-medium ">
                <label htmlFor="message" className="block w-[160px] font-semibold font-inter desktop:mb-0 mb-3">
                  문의내용
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  className="flex-1 w-full rounded-md border border-custom2 px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  required
                />
              </div>
            </div>

            <div className="desktop:mt-[69px] mt-[30px] flex justify-center">
              <button
                type="submit"
                className="w-[289px] px-8 py-[15px] bg-primary rounded-lg backdrop-blur-[6px] transition-colors duration-200 hover:bg-primary hover:shadow-md kr-font"
              >
                <div className="text-primary-background text-headline-small font-semibold font-inter">
                  문의하기
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
} 